import { render, staticRenderFns } from "./MessageNotification.vue?vue&type=template&id=1fa9d695&scoped=true&"
import script from "./MessageNotification.vue?vue&type=script&lang=js&"
export * from "./MessageNotification.vue?vue&type=script&lang=js&"
import style0 from "./MessageNotification.vue?vue&type=style&index=0&id=1fa9d695&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa9d695",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/MessageNotification.vue
// module id = null
// module chunks = 